/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as BookmarksRouteImport } from './routes/bookmarks'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAuditLogRouteImport } from './routes/admin.audit-log'
import { Route as AdminExamsRouteImport } from './routes/admin.exams'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as ExamExamSlugRouteImport } from './routes/exam.$examSlug'
import { Route as AdminDirectoriesDirectoryIdFilesRouteImport } from './routes/admin.directories.$directoryId.files'
import { Route as AdminExamsExamIdSubjectsRouteImport } from './routes/admin.exams.$examId.subjects'
import { Route as AdminSubjectsSubjectIdStructureRouteImport } from './routes/admin.subjects.$subjectId.structure'
import { Route as ExamExamSlugSubjectSubjectSlugRouteImport } from './routes/exam.$examSlug.subject.$subjectSlug'
import { Route as ExamExamSlugSubjectSubjectSlugModuleKeySplatRouteImport } from './routes/exam.$examSlug.subject.$subjectSlug.$moduleKey.$'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const BookmarksRoute = BookmarksRouteImport.update({
  id: '/bookmarks',
  path: '/bookmarks',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditLogRoute = AdminAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AdminRoute,
} as any)
const AdminExamsRoute = AdminExamsRouteImport.update({
  id: '/exams',
  path: '/exams',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const ExamExamSlugRoute = ExamExamSlugRouteImport.update({
  id: '/exam/$examSlug',
  path: '/exam/$examSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDirectoriesDirectoryIdFilesRoute =
  AdminDirectoriesDirectoryIdFilesRouteImport.update({
    id: '/directories/$directoryId/files',
    path: '/directories/$directoryId/files',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminExamsExamIdSubjectsRoute =
  AdminExamsExamIdSubjectsRouteImport.update({
    id: '/$examId/subjects',
    path: '/$examId/subjects',
    getParentRoute: () => AdminExamsRoute,
  } as any)
const AdminSubjectsSubjectIdStructureRoute =
  AdminSubjectsSubjectIdStructureRouteImport.update({
    id: '/subjects/$subjectId/structure',
    path: '/subjects/$subjectId/structure',
    getParentRoute: () => AdminRoute,
  } as any)
const ExamExamSlugSubjectSubjectSlugRoute =
  ExamExamSlugSubjectSubjectSlugRouteImport.update({
    id: '/subject/$subjectSlug',
    path: '/subject/$subjectSlug',
    getParentRoute: () => ExamExamSlugRoute,
  } as any)
const ExamExamSlugSubjectSubjectSlugModuleKeySplatRoute =
  ExamExamSlugSubjectSubjectSlugModuleKeySplatRouteImport.update({
    id: '/$moduleKey/$',
    path: '/$moduleKey/$',
    getParentRoute: () => ExamExamSlugSubjectSubjectSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/bookmarks': typeof BookmarksRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/search': typeof SearchRoute
  '/signup': typeof SignupRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/exams': typeof AdminExamsRouteWithChildren
  '/admin/reports': typeof AdminReportsRoute
  '/admin/users': typeof AdminUsersRoute
  '/exam/$examSlug': typeof ExamExamSlugRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/admin/directories/$directoryId/files': typeof AdminDirectoriesDirectoryIdFilesRoute
  '/admin/exams/$examId/subjects': typeof AdminExamsExamIdSubjectsRoute
  '/admin/subjects/$subjectId/structure': typeof AdminSubjectsSubjectIdStructureRoute
  '/exam/$examSlug/subject/$subjectSlug': typeof ExamExamSlugSubjectSubjectSlugRouteWithChildren
  '/exam/$examSlug/subject/$subjectSlug/$moduleKey/$': typeof ExamExamSlugSubjectSubjectSlugModuleKeySplatRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bookmarks': typeof BookmarksRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/search': typeof SearchRoute
  '/signup': typeof SignupRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/exams': typeof AdminExamsRouteWithChildren
  '/admin/reports': typeof AdminReportsRoute
  '/admin/users': typeof AdminUsersRoute
  '/exam/$examSlug': typeof ExamExamSlugRouteWithChildren
  '/admin': typeof AdminIndexRoute
  '/admin/directories/$directoryId/files': typeof AdminDirectoriesDirectoryIdFilesRoute
  '/admin/exams/$examId/subjects': typeof AdminExamsExamIdSubjectsRoute
  '/admin/subjects/$subjectId/structure': typeof AdminSubjectsSubjectIdStructureRoute
  '/exam/$examSlug/subject/$subjectSlug': typeof ExamExamSlugSubjectSubjectSlugRouteWithChildren
  '/exam/$examSlug/subject/$subjectSlug/$moduleKey/$': typeof ExamExamSlugSubjectSubjectSlugModuleKeySplatRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/bookmarks': typeof BookmarksRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/search': typeof SearchRoute
  '/signup': typeof SignupRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/exams': typeof AdminExamsRouteWithChildren
  '/admin/reports': typeof AdminReportsRoute
  '/admin/users': typeof AdminUsersRoute
  '/exam/$examSlug': typeof ExamExamSlugRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/admin/directories/$directoryId/files': typeof AdminDirectoriesDirectoryIdFilesRoute
  '/admin/exams/$examId/subjects': typeof AdminExamsExamIdSubjectsRoute
  '/admin/subjects/$subjectId/structure': typeof AdminSubjectsSubjectIdStructureRoute
  '/exam/$examSlug/subject/$subjectSlug': typeof ExamExamSlugSubjectSubjectSlugRouteWithChildren
  '/exam/$examSlug/subject/$subjectSlug/$moduleKey/$': typeof ExamExamSlugSubjectSubjectSlugModuleKeySplatRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/bookmarks'
    | '/login'
    | '/profile'
    | '/search'
    | '/signup'
    | '/admin/audit-log'
    | '/admin/exams'
    | '/admin/reports'
    | '/admin/users'
    | '/exam/$examSlug'
    | '/admin/'
    | '/admin/directories/$directoryId/files'
    | '/admin/exams/$examId/subjects'
    | '/admin/subjects/$subjectId/structure'
    | '/exam/$examSlug/subject/$subjectSlug'
    | '/exam/$examSlug/subject/$subjectSlug/$moduleKey/$'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bookmarks'
    | '/login'
    | '/profile'
    | '/search'
    | '/signup'
    | '/admin/audit-log'
    | '/admin/exams'
    | '/admin/reports'
    | '/admin/users'
    | '/exam/$examSlug'
    | '/admin'
    | '/admin/directories/$directoryId/files'
    | '/admin/exams/$examId/subjects'
    | '/admin/subjects/$subjectId/structure'
    | '/exam/$examSlug/subject/$subjectSlug'
    | '/exam/$examSlug/subject/$subjectSlug/$moduleKey/$'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/bookmarks'
    | '/login'
    | '/profile'
    | '/search'
    | '/signup'
    | '/admin/audit-log'
    | '/admin/exams'
    | '/admin/reports'
    | '/admin/users'
    | '/exam/$examSlug'
    | '/admin/'
    | '/admin/directories/$directoryId/files'
    | '/admin/exams/$examId/subjects'
    | '/admin/subjects/$subjectId/structure'
    | '/exam/$examSlug/subject/$subjectSlug'
    | '/exam/$examSlug/subject/$subjectSlug/$moduleKey/$'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  BookmarksRoute: typeof BookmarksRoute
  LoginRoute: typeof LoginRoute
  ProfileRoute: typeof ProfileRoute
  SearchRoute: typeof SearchRoute
  SignupRoute: typeof SignupRoute
  ExamExamSlugRoute: typeof ExamExamSlugRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookmarks': {
      id: '/bookmarks'
      path: '/bookmarks'
      fullPath: '/bookmarks'
      preLoaderRoute: typeof BookmarksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit-log': {
      id: '/admin/audit-log'
      path: '/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AdminAuditLogRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/exams': {
      id: '/admin/exams'
      path: '/exams'
      fullPath: '/admin/exams'
      preLoaderRoute: typeof AdminExamsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/exam/$examSlug': {
      id: '/exam/$examSlug'
      path: '/exam/$examSlug'
      fullPath: '/exam/$examSlug'
      preLoaderRoute: typeof ExamExamSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/directories/$directoryId/files': {
      id: '/admin/directories/$directoryId/files'
      path: '/directories/$directoryId/files'
      fullPath: '/admin/directories/$directoryId/files'
      preLoaderRoute: typeof AdminDirectoriesDirectoryIdFilesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/exams/$examId/subjects': {
      id: '/admin/exams/$examId/subjects'
      path: '/$examId/subjects'
      fullPath: '/admin/exams/$examId/subjects'
      preLoaderRoute: typeof AdminExamsExamIdSubjectsRouteImport
      parentRoute: typeof AdminExamsRoute
    }
    '/admin/subjects/$subjectId/structure': {
      id: '/admin/subjects/$subjectId/structure'
      path: '/subjects/$subjectId/structure'
      fullPath: '/admin/subjects/$subjectId/structure'
      preLoaderRoute: typeof AdminSubjectsSubjectIdStructureRouteImport
      parentRoute: typeof AdminRoute
    }
    '/exam/$examSlug/subject/$subjectSlug': {
      id: '/exam/$examSlug/subject/$subjectSlug'
      path: '/subject/$subjectSlug'
      fullPath: '/exam/$examSlug/subject/$subjectSlug'
      preLoaderRoute: typeof ExamExamSlugSubjectSubjectSlugRouteImport
      parentRoute: typeof ExamExamSlugRoute
    }
    '/exam/$examSlug/subject/$subjectSlug/$moduleKey/$': {
      id: '/exam/$examSlug/subject/$subjectSlug/$moduleKey/$'
      path: '/$moduleKey/$'
      fullPath: '/exam/$examSlug/subject/$subjectSlug/$moduleKey/$'
      preLoaderRoute: typeof ExamExamSlugSubjectSubjectSlugModuleKeySplatRouteImport
      parentRoute: typeof ExamExamSlugSubjectSubjectSlugRoute
    }
  }
}

interface AdminExamsRouteChildren {
  AdminExamsExamIdSubjectsRoute: typeof AdminExamsExamIdSubjectsRoute
}

const AdminExamsRouteChildren: AdminExamsRouteChildren = {
  AdminExamsExamIdSubjectsRoute: AdminExamsExamIdSubjectsRoute,
}

const AdminExamsRouteWithChildren = AdminExamsRoute._addFileChildren(
  AdminExamsRouteChildren,
)

interface AdminRouteChildren {
  AdminAuditLogRoute: typeof AdminAuditLogRoute
  AdminExamsRoute: typeof AdminExamsRouteWithChildren
  AdminReportsRoute: typeof AdminReportsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminDirectoriesDirectoryIdFilesRoute: typeof AdminDirectoriesDirectoryIdFilesRoute
  AdminSubjectsSubjectIdStructureRoute: typeof AdminSubjectsSubjectIdStructureRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAuditLogRoute: AdminAuditLogRoute,
  AdminExamsRoute: AdminExamsRouteWithChildren,
  AdminReportsRoute: AdminReportsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminDirectoriesDirectoryIdFilesRoute: AdminDirectoriesDirectoryIdFilesRoute,
  AdminSubjectsSubjectIdStructureRoute: AdminSubjectsSubjectIdStructureRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ExamExamSlugSubjectSubjectSlugRouteChildren {
  ExamExamSlugSubjectSubjectSlugModuleKeySplatRoute: typeof ExamExamSlugSubjectSubjectSlugModuleKeySplatRoute
}

const ExamExamSlugSubjectSubjectSlugRouteChildren: ExamExamSlugSubjectSubjectSlugRouteChildren =
  {
    ExamExamSlugSubjectSubjectSlugModuleKeySplatRoute:
      ExamExamSlugSubjectSubjectSlugModuleKeySplatRoute,
  }

const ExamExamSlugSubjectSubjectSlugRouteWithChildren =
  ExamExamSlugSubjectSubjectSlugRoute._addFileChildren(
    ExamExamSlugSubjectSubjectSlugRouteChildren,
  )

interface ExamExamSlugRouteChildren {
  ExamExamSlugSubjectSubjectSlugRoute: typeof ExamExamSlugSubjectSubjectSlugRouteWithChildren
}

const ExamExamSlugRouteChildren: ExamExamSlugRouteChildren = {
  ExamExamSlugSubjectSubjectSlugRoute:
    ExamExamSlugSubjectSubjectSlugRouteWithChildren,
}

const ExamExamSlugRouteWithChildren = ExamExamSlugRoute._addFileChildren(
  ExamExamSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  BookmarksRoute: BookmarksRoute,
  LoginRoute: LoginRoute,
  ProfileRoute: ProfileRoute,
  SearchRoute: SearchRoute,
  SignupRoute: SignupRoute,
  ExamExamSlugRoute: ExamExamSlugRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
